// extracted by mini-css-extract-plugin
module.exports = {"private_layout":"styles_private_layout__3aEnW"};